<template>
  <div id="app-root">
    <transition :name="transitionName" mode="out-in">
      <router-view class="page-view" />
    </transition>
    <FloatingMenu />
  </div>
</template>

<script>
import FloatingMenu from './components/FloatingMenu.vue'

export default {
  name: 'App',
  components: { FloatingMenu },
  data() {
    return {
      transitionName: 'fade'
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/' && from.path) {
        this.transitionName = 'fade-back'
      } else {
        this.transitionName = 'fade'
      }
    }
  }
}
</script>

<style>
#app-root {
  min-height: 100vh;
}
</style>
